<script>
import CheckboxGroup from 'element-ui/lib/checkbox-group';

export default CheckboxGroup;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/checkbox.css';
@import '../../stylesheets/utils/utils';

/* @import "../../stylesheets/element-theme/checkbox-group.css";*/

.el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
}
</style>
